export function scrollToSection(hash) {
    const el = document.querySelector(hash);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -64, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
}
